module.exports = __webpack_public_path__ + "images/magnate-501faf387814648e83b4af1e0f7e5ace.png";